const DEFAULT_MAX_CHARS = 50;

const chunks = (query: string): RegExpMatchArray =>
  query
    .replace(/[\r\n\s]+/g, " ") // Consolidate consecutive whitespace including newlines
    .match(/\s*?(?<verb>(SELECT|DELETE)\s+.*FROM|INSERT\s+INTO|UPDATE)\s+"?(?<firstTableName>\w+)"?/i);

export function summarizeQuery(query: string, options?: { maxChars?: number }): string {
  const matches = chunks(query);

  // Queries that don't begin with SELECT|DELETE|INSERT|UPDATE are truncated
  if (!matches) {
    return query.slice(0, options?.maxChars ?? DEFAULT_MAX_CHARS);
  }

  // Ignore field names in SELECT queries
  const trimmedVerb = matches.groups.verb.replace(/SELECT .* FROM/i, "SELECT FROM").toUpperCase();

  return `${trimmedVerb} ${matches.groups.firstTableName}`;
}

export function firstTableNamedInQuery(query: string): string | undefined {
  return chunks(query).groups.firstTableName;
}
